/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Spin } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import DOMPurify from 'dompurify'
import { CustomRow } from './TermsAndConditions.styles'
import { api } from '../../api/api'
import { REQUEST_STATUS } from '../../utils/types'
import { isLoading } from '../../utils/functions'

const TermsAndConditions: React.FC = (): JSX.Element => {
    const [contentString, setContentString] = useState('')
    const [requestStatus, setRequestStatus] = useState<REQUEST_STATUS>(
        REQUEST_STATUS.NONE
    )
    useEffect(() => {
        setRequestStatus(REQUEST_STATUS.PENDING)
        api.get('/api/setting/termConditions')
            .then((result: any) => {
                setContentString(DOMPurify.sanitize(result.data))
                setRequestStatus(REQUEST_STATUS.SUCCESS)
            })
            .catch(() => {
                setRequestStatus(REQUEST_STATUS.FAILED)
            })
    }, [])
    return (
        <>
            <Helmet title="Terms & Conditions" />
            {isLoading(requestStatus) ? (
                <CustomRow justify="center" align="middle">
                    <Spin />
                </CustomRow>
            ) : (
                <CustomRow justify="left" align="top">
                    <Content style={{ padding: '0 50px' }}>
                        <div
                            className="termsAndConditions"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: contentString }}
                        />
                    </Content>
                </CustomRow>
            )}
        </>
    )
}

export default TermsAndConditions
